var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3d311b989cc84f72e3647a697fae6f59bef49c43"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["aiaiai-app@aiaiai"]={id:"3d311b989cc84f72e3647a697fae6f59bef49c43"};
      